import axios from "axios";
import React, { useEffect, useState } from "react";
import AwesomeSlider from "react-awesome-slider";
import 'react-awesome-slider/dist/styles.css';
import 'react-awesome-slider/dist/custom-animations/open-animation.css';
import useFetchAPI from "../hooks/useFetchAPI";

function Home() {
   const { data, loading, error } = useFetchAPI("/api/home", {
    populate: { navigations: "*" },
  });

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading home data</p>;
  const navigation = data.navigations;
  console.log("nav", navigation)
  return (
    <div>
      <h1>Home Page</h1>
      <ul>
        {
          navigation?.map((nav, index)=>
            <li key={index}>{nav.navigation_title}
              <ul>
                {
                 nav.navigation_title === "Our Service" &&
                 nav.sub_navigations.map((subNav)=>
                  <li>{subNav.sub_nav_title}</li>
                )

                 }
                
              </ul>
            </li>
          )
        }
      </ul>
    </div>
  );
}

export default Home;
